import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateCSS } from 'shared/utils/update-css';

import WixSDK from 'shared/utils/wix-sdk';

import {
  updateAppSettings,
  fetchAppSettings,
} from 'widget/redux/client/actions/app-settings';
import { getChannelIdFromAppSettings } from 'shared/selectors/app-settings';
import { getChannelId } from 'widget/utils/app-settings';

const { STYLE_PARAMS_CHANGE, EDIT_MODE_CHANGE } = WixSDK.Events;

@connect(
  state => ({
    appSettings: state.appSettings,
    currentChannelId: getChannelIdFromAppSettings(state),
  }),
  {
    updateAppSettings,
    fetchAppSettings,
  },
)
export class AppSettingsLoader extends React.Component {
  static propTypes = {
    children: PropTypes.func,
    appSettings: PropTypes.object,
    currentChannelId: PropTypes.string,
    updateAppSettings: PropTypes.func.isRequired,
  };

  handleEditModeChange = _.debounce(({ editMode }) => {
    this.props.updateAppSettings({ editMode });
  }, 100);

  handleStylesChange = _.debounce(styleParams => {
    const { currentChannelId } = this.props;

    WixSDK.Styles.extendStylesWithInitialChannelId(styleParams).then(
      updatedStyles => {
        const isChanged = currentChannelId !== getChannelId(updatedStyles);

        if (isChanged) {
          window.location.reload();
        } else {
          updateCSS(updatedStyles);
          this.props.updateAppSettings(updatedStyles);
        }
      },
    );
  }, 100);

  componentDidMount() {
    this.props.fetchAppSettings().then(() => {
      WixSDK.addEventListener(STYLE_PARAMS_CHANGE, this.handleStylesChange);
      WixSDK.addEventListener(EDIT_MODE_CHANGE, this.handleEditModeChange);
    });
  }

  componentWillUnmount() {
    WixSDK.removeEventListener(STYLE_PARAMS_CHANGE, this.handleStylesChange);
    WixSDK.removeEventListener(EDIT_MODE_CHANGE, this.handleEditModeChange);
  }

  render() {
    const { appSettings, children } = this.props;

    window.test = this;

    if (appSettings && children) {
      return children(appSettings);
    }

    return null;
  }
}
